import React from 'react';
import {BeatLoader} from "react-spinners";
import {Box} from "@mui/system";
import {COLORS} from "../../ui/Theme";

const ThreeDotsLoading = ({size, bgWidth, bgHeight, backgroundColor}) => {

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: backgroundColor && COLORS.SOFTGRAY,
                borderRadius: backgroundColor && "10px",
                width: bgWidth ? bgWidth : "100%",
                height: bgHeight ? bgHeight : "100%",
            }}
        >
            <BeatLoader
                size={size}
                color={COLORS.BLUE}
            />
        </Box>
    );
};

export default ThreeDotsLoading;